module.exports = __webpack_public_path__ + "15_vast_poster.pdf?a87db800cb6e7ddc7fe23949d12e36f3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperData/15_vast_poster.pdf
// module id = 149
// module chunks = 0